export default __webpack_public_path__ + "static/media/sobreNos_RightSide.2cf0ef73.svg";